import {graphql, useStaticQuery} from 'gatsby';

type Data = {
	slugs: {
		locations: {
			name: string,
			slug: string,
		}[]
	}
};

const query = graphql`
{
	slugs: bodyspec {
		locations {
			name
			slug
		}
	}
}`;

export const useSlugs = (): Record<string, string> => {
	const data = useStaticQuery<Data>(query);

	return data.slugs.locations
		.reduce((acc, curr) => {
			return {
				...acc,
				[curr.slug]: curr.name,
			};
		});
};
